import { Alert } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { listAllUsersByType } from '../../api/api-middleware';
import { listCategoriesAll, listProductsAll } from '../../api/products';
import HomeContent from '../../components/Home';
import Loading from '../../components/Loading/loading';
import useAuthToken from '../../hooks/getUserData';
import DashboardLayout from '../../layout/dashboard/DashboardLayout';

const HomePage2 = () => {
  const [registryUsers, setRegistryUsers] = useState(0);
  const [recommendationUsers, setRecommendationUsers] = useState(0);
  const [productCount, setProductCount] = useState(0); 
  const [categoryCount, setCategoryCount] = useState(0); 
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const token = useAuthToken();

  const fetchUserData = async () => {
    setLoading(true);
    try {
      if (token) {
        const [registryRes, recommendationRes] = await Promise.all([
          listAllUsersByType('registry', token),
          listAllUsersByType('recommendation', token),
        ]);

        if (registryRes.ok) {
          const registryData = await registryRes.json();
          setRegistryUsers(registryData.count);
        }

        if (recommendationRes.ok) {
          const recommendationData = await recommendationRes.json();
          setRecommendationUsers(recommendationData.count);
        }
      }
    } catch (error) {
      setError('An error occurred while fetching data');
    } finally {
      setLoading(false);
    }
  };

  const fetchProductAndCategoryCounts = async () => {
    try {
      if (token) {
        const [productRes, categoryRes] = await Promise.all([
          listProductsAll(token),
          listCategoriesAll(token),
        ]);

        if (productRes.ok) {
          const productData = await productRes.json();
          setProductCount(productData.count);
        }

        if (categoryRes.ok) {
          const categoryData = await categoryRes.json();
          setCategoryCount(categoryData.count);
        }
      }
    } catch (error) {
      setError('An error occurred while fetching data');
    }
  };

  useEffect(() => {
    if (token) {
      Promise.all([fetchUserData(), fetchProductAndCategoryCounts()]).then(
        () => {
          setLoading(false);
        }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <DashboardLayout>
      {loading ? (
        <Loading />
      ) : (
        <>
          {error ? (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          ) : (
            <HomeContent
              registryUsers={registryUsers}
              recommendationUsers={recommendationUsers}
              productCount={productCount}
              categoryCount={categoryCount}
            />
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default HomePage2;
